/** Cache the user's country code from the geo edge function */
let cachedCountry: string | null = null;

export async function getUserCountry(): Promise<string> {
  if (cachedCountry) return cachedCountry;
  let country: string;
  try {
    const resp = await fetch("/api/geo");
    const data = await resp.json();
    country = data.country ?? "US";
  } catch {
    country = "US";
  }
  cachedCountry = country;
  return country;
}

export async function isInIsrael(): Promise<boolean> {
  const country = await getUserCountry();
  return country === "IL";
}
